import { Fragment as _Fragment } from "react/jsx-runtime";
import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Button, Box, Heading, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import Image from 'next/image';
import dotPattern from '../../../public/landing/dot_pattern.svg';
import wavePattern from '../../../public/landing/wave_pattern.svg';
import { ArrowForwardIcon } from '@chakra-ui/icons';
export default function CallToActionWithIllustration() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      textAlign: 'center',
      align: 'center',
      spacing: {
        base: 8,
        md: 10
      },
      py: {
        base: 20,
        md: 28
      },
      children: [/*#__PURE__*/_jsxs(Heading, {
        fontWeight: 900,
        fontSize: {
          base: '3xl',
          sm: '4xl',
          md: '6xl'
        },
        lineHeight: '110%',
        children: ["Your autonomous", ' ', /*#__PURE__*/_jsx(Text, {
          as: 'span',
          color: 'brand.500',
          children: "Publications Hub"
        })]
      }), /*#__PURE__*/_jsxs(Text, {
        fontSize: "xl",
        children: ["Showcase your achievements to the world", ' ', /*#__PURE__*/_jsx(Text, {
          as: "span",
          fontWeight: "bold",
          children: "gain new collaboration"
        }), ' ', "and keep every person in you faculty", ' ', /*#__PURE__*/_jsx(Text, {
          as: "span",
          fontWeight: "bold",
          children: "up to date."
        }), ' ', "With Articali you can create an", ' ', /*#__PURE__*/_jsx(Text, {
          as: "span",
          fontWeight: "bold",
          children: "autonomous publication hub"
        }), ", that automatically gets the latest publications of your faculty members, and show them in an elegant and engaging place."]
      }), /*#__PURE__*/_jsxs(Stack, {
        spacing: 6,
        direction: 'row',
        children: [/*#__PURE__*/_jsx(NextLink, {
          href: '/signup',
          passHref: true,
          children: /*#__PURE__*/_jsx(Button, {
            px: 6,
            colorScheme: "brand",
            rightIcon: /*#__PURE__*/_jsx(ArrowForwardIcon, {}),
            children: "Get Started"
          })
        }), /*#__PURE__*/_jsx(NextLink, {
          href: "#features",
          passHref: true,
          children: /*#__PURE__*/_jsxs(Button, {
            px: 6,
            variant: "ghost",
            children: ["Learn more", ' ']
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      position: "absolute",
      top: "80px",
      left: "0",
      display: ['none', null, null, 'block'],
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, dotPattern), {}, {
        alt: "dot pattern"
      }))
    }), /*#__PURE__*/_jsx(Box, {
      position: "absolute",
      top: "80px",
      right: "20px",
      display: ['none', null, null, 'block'],
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, wavePattern), {}, {
        alt: "wave pattern"
      }))
    })]
  });
}